import React from 'react';
import { TableRow, TableCell, Box, Typography, Chip } from '@mui/material';
import { Star as StarIcon } from '@mui/icons-material';
import { formatDateTime } from '../../../../utils/dateUtils';
import PropTypes from 'prop-types';

/**
 * FeedbackTableRow Component
 * Table row for a single feedback item
 */
const FeedbackTableRow = ({ feedback }) => {
  const renderRating = rating => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <StarIcon
          key={i}
          sx={{
            color: i <= rating ? 'warning.main' : 'grey.300',
            fontSize: '1rem',
          }}
        />
      );
    }
    return (
      <Box display="flex" gap={0.25}>
        {stars}
      </Box>
    );
  };

  return (
    <TableRow key={feedback.id} hover>
      <TableCell>
        <Box display="flex" alignItems="center" gap={1}>
          {renderRating(feedback.rating)}
          <Typography variant="body2" sx={{ ml: 1 }}>
            {feedback.rating}/5
          </Typography>
        </Box>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {formatDateTime(feedback.created_at)}
        </Typography>
      </TableCell>
      <TableCell>
        <Chip
          label={`v${feedback.template_version || '?'}`}
          size="small"
          color="primary"
          variant="outlined"
        />
      </TableCell>
      <TableCell>
        <Typography
          variant="body2"
          sx={{
            maxWidth: 400,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
          title={feedback.feedback_text || 'No feedback text'}
        >
          {feedback.feedback_text || (
            <Typography
              component="span"
              color="text.secondary"
              fontStyle="italic"
            >
              No feedback text
            </Typography>
          )}
        </Typography>
      </TableCell>
      <TableCell>
        <Box display="flex" gap={0.5} flexWrap="wrap">
          {feedback.categories && feedback.categories.length > 0 ? (
            feedback.categories.map((category, idx) => (
              <Chip
                key={idx}
                label={category}
                size="small"
                variant="outlined"
              />
            ))
          ) : (
            <Typography variant="caption" color="text.secondary">
              None
            </Typography>
          )}
        </Box>
      </TableCell>
      <TableCell>
        <Typography
          variant="body2"
          sx={{
            fontFamily: 'monospace',
            fontSize: '0.75rem',
            maxWidth: 200,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
          title={feedback.execution_id}
        >
          {feedback.execution_id}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {feedback.created_by || (
            <Typography component="span" color="text.secondary">
              Unknown
            </Typography>
          )}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

FeedbackTableRow.propTypes = {
  feedback: PropTypes.object.isRequired,
};

export default FeedbackTableRow;
